
export default ()=>({
    beforeLocation(data) {
        if (data) {
            if (typeof data.name == 'string' &&  !data.name.trim()) {
                return new Error('请填写广告名称')
            }
        }
    }
})